import { render, staticRenderFns } from "./CreateSession.vue?vue&type=template&id=4c553039&scoped=true&"
import script from "./CreateSession.vue?vue&type=script&lang=js&"
export * from "./CreateSession.vue?vue&type=script&lang=js&"
import style0 from "./CreateSession.vue?vue&type=style&index=0&id=4c553039&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c553039",
  null
  
)

export default component.exports